import { useSelector } from "react-redux";
import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { FAQItem } from "domain/payload/response/faq/FAQResp";

const FAQService = () => {
  const { token } = useSelector((state: any) => state.auth);

  const getFAQList = async (
    type: string = "RETAIL_PARTNER_FAQ"
  ): Promise<BaseResponse<FAQItem[]>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/public/faq/list?type=${type}`,
        {
          headers: {
            ...axiosInstance.defaults.headers.head,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message;
    }
  };

  return { getFAQList };
};

export default FAQService;
